export default {
    nakuHistory: state => state.nakuHistory,
    iyzicoPaymentDialog: state => state.iyzicoPaymentDialog,
    ThreedHtml: state => state.ThreedHtml,
    paymentForm: state => state.paymentForm,
    buyNakuResponse: state => state.buyNakuResponse,
}